var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPresenceAvailableAssociate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.32,20.54a3.44,3.44,0,0,1-3.21-3.6,3.29,3.29,0,0,1,3.09-3.49h.12a3.28,3.28,0,0,1,3.2,3.36h0a.11.11,0,0,1,0,.08,3.43,3.43,0,0,1-3.19,3.64Z",
    style: {
      fill: "#9767b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.31,14A4.11,4.11,0,0,1,20,12.9a6.19,6.19,0,0,0,.22-1.61v-.12A5,5,0,0,0,15.33,6h-.15a5,5,0,0,0-4.77,5.29c0,3,2.19,5.51,4.9,5.51a4.32,4.32,0,0,0,2-.47A4,4,0,0,1,18.31,14Z",
    style: {
      fill: "#6bae44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.31,26a1.32,1.32,0,0,1-1-.36c-.17-.2-.05-.62.06-.86l.27-.58a11.55,11.55,0,0,1,1.63-2.48,1.27,1.27,0,0,1,1.54-.24,4.22,4.22,0,0,1,.73.61,2.58,2.58,0,0,0,1.63.54h.5a2.49,2.49,0,0,0,1.59-.54,4.29,4.29,0,0,1,.66-.62,1.16,1.16,0,0,1,1.44.25,10.53,10.53,0,0,1,1.53,2.55l.29.57c.11.24.23.65.08.86a1.22,1.22,0,0,1-.92.34Z",
    style: {
      fill: "#9767b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.63,24.4l.28-.59a13,13,0,0,1,1.74-2.67,2.13,2.13,0,0,1,2.56-.44,4.49,4.49,0,0,1-1.73-2.35,6.38,6.38,0,0,0-.51.53,3.75,3.75,0,0,1-2.45.83h-.76a3.88,3.88,0,0,1-2.49-.83,6.57,6.57,0,0,0-1.13-1,2,2,0,0,0-2.37.45,18.31,18.31,0,0,0-2.49,3.8L4.87,23c-.17.37-.35,1-.1,1.33a2,2,0,0,0,1.51.53h8.17A2.22,2.22,0,0,1,14.63,24.4Z",
    style: {
      fill: "#6bae44"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceAvailableAssociate);
export default __webpack_public_path__ + "static/media/presence-available-associate.1147c590.svg";
export { ForwardRef as ReactComponent };